"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _TextContent = _interopRequireDefault(require("./TextContent"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var TextAttachment = function TextAttachment(_ref) {
  var _ref$attachment = _ref.attachment;
  _ref$attachment = _ref$attachment === void 0 ? {} : _ref$attachment;
  var content = _ref$attachment.content,
      contentType = _ref$attachment.contentType;
  return !!content && _react.default.createElement(_TextContent.default, {
    contentType: contentType,
    text: content
  });
};

TextAttachment.propTypes = {
  attachment: _propTypes.default.shape({
    content: _propTypes.default.string.isRequired,
    contentType: _propTypes.default.string.isRequired
  }).isRequired
};
var _default = TextAttachment;
exports.default = _default;